import { FormObjType } from "DataTypes/Form";
import DateTime from "Utils/DateTime";

export const InsuranceForm: FormObjType[] = [
  {
    id: "companyId",
    label: "Company Id",
    placeholder: "Enter Company ID",
    boxType: "input",
    boxSize: 3,
    validatetype: "alphaNum50",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "companyName",
    label: "Company Name",
    placeholder: "Enter Company Name",
    boxType: "input",
    boxSize: 3,
    validatetype: "name150",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "planId",
    label: "Plan Id",
    placeholder: "Enter Plan ID",
    boxType: "input",
    boxSize: 3,
    validatetype: "alphaNum50",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "planName",
    label: "Plan Name",
    placeholder: "Enter Plan Name",
    boxType: "input",
    boxSize: 3,
    validatetype: "name100",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "policyNumber",
    label: "Policy Number",
    placeholder: "Enter Policy Number",
    boxType: "input",
    boxSize: 3,
    validatetype: "alphaNum50",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "effectiveDate",
    label: "Effective Date",
    placeholder: "Select Effective Date",
    boxType: "date",
    boxSize: 3,
    validatetype: "date",
    enableFormLoad: true,
    required: true,
    maxVal: DateTime.CurrentDate(),
    dateType: "start"
  },
  {
    id: "expirationDate",
    label: "Expiration Date",
    placeholder: "Select Expiration Date",
    boxType: "date",
    boxSize: 3,
    validatetype: "date",
    enableFormLoad: true,
    required: true,
    dateType: "stop",
    minVal: DateTime.CurrentDate(),
  },
  {
    id: "priority",
    label: "Priority",
    placeholder: "Select priority",
    boxType: "input",
    boxSize: 3,
    validatetype: "name50",
    required: true,
    enableFormLoad: true,
    readOnly: true
  },
]